export class DriveAndMachineContentModel {
    public driveAndMachineId: number;
    public langId: number;
    public driveDescription: string;
    public machineDescription: string;
}